module.exports = __webpack_public_path__ + "static/img/model-bg9.bc8bfe4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg9.jpg
// module id = KjAH
// module chunks = 0